import React from 'react';
import '../../App.css';
import ErrorIcon from '@material-ui/icons/Error';

export default function Error() {
    return (<div className="App">
        <ErrorIcon color="error" fontSize="large" />
        <p> Your session has now expired, please punchout to SupplyCAT again via MyMRO to continue shopping</p>
    </div>)
}